const merchfox = [
    {
        "id": "659d650c8257f",
        "name": "Sweatshirt 2D US",
        "sku": "Unisex-Gildan-Sweatshirt",
        "color": [
            "BLACK",
            "FOREST GREEN",
            "SAND",
            "SPORT GREY",
            "LIGHT PINK",
            "MILITARY GREEN",
            "MAROON",
            "RED",
            "ROYAL BLUE",
            "ASH GREY",
            "WHITE",
            "ORANGE",
            "NAVY",
            "DARK HEATHER",
            "ANTIQUE CHERRY RED",
            "CARDINAL RED",
            "CAROLINA BLUE",
            "CHARCOAL",
            "CHERRY RED",
            "DARK CHOCOLATE",
            "GARNET",
            "GOLD",
            "GRAPHITE HEATHER",
            "HEATHER DARK GREEN",
            "HEATHER DARK MAROON",
            "HEATHER DARK NAVY",
            "HEATHER DEEP ROYAL",
            "HEATHER SCARLET RED",
            "HELICONIA",
            "INDIGO BLUE",
            "IRISH GREEN",
            "LIGHT BLUE",
            "PURPLE",
            "SAFETY GREEN",
            "SORANGE",
            "SAFETY PINK",
            "SAPPHIRE"
        ],
        "size": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
        ],
    },
    {
        "id": "659d64fa2f51e",
        "name": "Hoodie 2D US",
        "sku": "Unisex-Gildan-Hoodie",
        "color": [
            "BLACK",
            "WHITE",
            "NAVY",
            "SPORT GREY",
            "SAND",
            "FOREST GREEN",
            "LIGHT PINK",
            "ANTIQUE CHERRY RED",
            "ANTIQUE SAPPHIRE",
            "ASHGREY",
            "AZALEA",
            "CARDINALRED",
            "CAROLINABLUE",
            "CHARCOAL",
            "CHERRY RED",
            "DARK CHOCOLATE",
            "DARK HEATHER",
            "GOLD",
            "GRAPHITE HEATHER",
            "HEATHER DARK GREEN",
            "HEATHER DARK MAROON",
            "HEATHER DARK NAVY",
            "HEATHER DEEP ROYAL",
            "HEATHER SCARLET RED",
            "HELICONIA",
            "INDIGO BLUE",
            "IRISH GREEN",
            "LIGHT BLUE",
            "MAROON",
            "MILITARY GREEN",
            "MINTGREEN",
            "OLD GOLD",
            "ORANGE",
            "ORCHID",
            "PURPLE",
            "RED",
            "ROYAL BLUE",
            "SAFETY GREEN",
            "SORANGE",
            "SAFETY PINK",
            "SAPPHIRE",
            "VIOLET"
        ],
        "size": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
        ],
    },
    {
        "id": "7a2b744651",
        "name": "Bella Canvas 3001 T-shirt 2D US",
        "sku": "Unisex-BellaCanvas-UnisexT-Shirt",
        "color": [
            "Black",
            "White",
            "Dark Grey Heather",
            "Natural",
            "AQUA",
            "ARMY",
            "ASHGREY",
            "ASPHALT",
            "ATLANTIC",
            "AUTUMN",
            "BABYBLUE",
            "BERRY",
            "BLUESTORM",
            "BROWN",
            "BURNTORANGE",
            "CANVASRED",
            "CARDINALRED_BC3001",
            "CAROLINABLUE_G5K",
            "CHARITYPINK",
            "CHESTNUT",
            "CITRON",
            "CLAY",
            "COCOA",
            "COLUMBIABLUE",
            "COOLBLUE",
            "CORAL",
            "DARKLAVENDER",
            "DARKOLIVE",
            "DEEPTEAL",
            "DUST",
            "DUSTYBLUE",
            "ELECTRICBLUE",
            "EVERGREEN",
            "FORESTGREEN",
            "FUCHSIA",
            "GOLD",
            "HUNTERGREEN",
            "KELLY",
            "LAVENDERBLUE",
            "LAVENDERDUST",
            "LEAF",
            "LIGHT BLUE",
            "LIGHTVIOLET",
            "LILAC",
            "MAIZE YELLOW",
            "MARINE",
            "MAROON",
            "MAUVE",
            "MILITARY GREEN",
            "MINT",
            "MUSTARD",
            "NAVY",
            "OCEANBLUE",
            "OLIVE",
            "ORANGE",
            "ORCHID",
            "OXBLOODBLACK",
            "PEACH",
            "PEBBLE BROWN",
            "PINE",
            "PINK GRAVEL",
            "PINK",
            "POPPY",
            "PURPLE STORM",
            "RED",
            "ROYAL PURPLE",
            "RUST",
            "SAGE",
            "SAND DUNE",
            "SILVER",
            "SLATE",
            "SOFT CREAM",
            "SOFT PINK",
            "SOLIDATHLETIC GREY",
            "SPRING GREEN",
            "STEEL BLUE",
            "STORM",
            "STROBE",
            "SUNSET",
            "SYNTHETIC GREEN",
            "TAN",
            "TEAL",
            "TEAM NAVY",
            "TEAM PURPLE",
            "TERRACOTTA",
            "THYME",
            "TOAST",
            "TRUEROYAL",
            "TURQUOISE",
            "VINTAGE BLACK",
            "VINTAGE BROWN",
            "VINTAGE DENIM",
            "VINTAGE NAVY",
            "VINTAGE RED",
            "VINTAGE WHITE",
            "YELLOW"
        ],
        "size": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
        ],
    },
    {
        "id": "659d64e4e2287",
        "name": "T-Shirt 2D US",
        "sku": "Unisex-Gildan-UnisexT-Shirt",
        "color": [
            "BLACK",
            "WHITE",
            "LIGHT BLUE",
            "CHARCOAL",
            "NAVY",
            "RED",
            "SPORT GREY",
            "MAROON",
            "DARK HEATHER",
            "ROYAL BLUE",
            "LIGHT PINK",
            "SAND",
            "FOREST GREEN",
            "ASH GREY",
            "PURPLE",
            "MILITARY GREEN",
            "ORANGE",
            "ANTIQUE CHERRY RED",
            "ANTIQUE IRISH GREEN",
            "ANTIQUE JADE DOME",
            "ANTIQUE ORANGE",
            "ANTIQUE SAPPHIRE",
            "AQUATIC",
            "AZALEA",
            "BERRY",
            "BLACKBERRY",
            "BLUE DUSK",
            "BROWN SAVANA",
            "CARDINAL",
            "CAROLINA BLUE",
            "COBALT",
            "CORAL SILK",
            "CORN SILK",
            "DAISY",
            "DARK CHOCOLATE",
            "DUSTY ROSE",
            "ELECTRIC GREEN",
            "GARNET",
            "GOLD",
            "GRAPHITE HEATHER",
            "GRAVEL",
            "HEATHER MILITARY GREEN",
            "HEATHER NAVY",
            "HEATHER RADIANT ORCHID",
            "HEATHER RED",
            "HEATHER SAPPHIRE",
            "HELICONIA",
            "ICE GREY",
            "INDIGO BLUE",
            "IRISH GREEN",
            "KIWI",
            "LILAC",
            "LIME",
            "MIDNIGHT",
            "MINT GREEN",
            "NATURAL",
            "NEON BLUE",
            "NEON GREEN",
            "OFF WHITE",
            "RUSSET",
            "SAFETY GREEN",
            "SAFETY ORANGE",
            "SAFETY PINK",
            "SAPPHIRE",
            "SKY",
            "SUNSET",
            "TANGERINE",
            "TENNESSEE ORANGE",
            "TEXAS ORANGE",
            "TROPICAL BLUE",
            "TURF GREEN",
            "TWEED",
            "VIOLET",
            "YELLOW HAZE"
        ],
        "size": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL",
            "5XL"
        ],
    },
    {
        "id": "58dda42030",
        "name": "Comfort 1717 T-Shirt 2D US",
        "sku": "Unisex-ComfortColor-UnisexT-Shirt",
        "color": [
            "Black",
            "White",
            "Pepper",
            "Ivory",
            "Espresso",
            "Blue Spruce",
            "Crimson",
            "Bay",
            "Moss",
            "Blue Jean",
            "Seafoam",
            "Grey",
            "Blossom",
            "Graphite",
            "Violet",
            "BANANA",
            "BERRY",
            "BOYSENBERRY",
            "BRICK",
            "BRIGHT ORANGE",
            "BRIGHT SALMON",
            "BURNT ORANGE",
            "BUTTER",
            "CHALKYMINT",
            "CHAMBRAY",
            "CHILI",
            "CHINA BLUE",
            "CITRUS",
            "CRUNCH BERRY",
            "DENIM",
            "EMERALD",
            "FLO BLUE",
            "GRANITE",
            "GRAPE",
            "GRASS",
            "HEMP",
            "HYDRANGEA",
            "ICEBLUE",
            "ISLAND REEF",
            "KHAKI",
            "LAGOON",
            "LIGHT GREEN",
            "MELON",
            "MIDNIGHT",
            "MUSTARD",
            "MYSTICBLUE",
            "NAVY",
            "NEON BLUE",
            "NEON CANTALOUPE",
            "NEON LEMON",
            "NEON PINK",
            "NEON REDORANGE",
            "NEON VIOLET",
            "ORCHID",
            "PAPRIKA",
            "PEACHY",
            "PERIWINKLE",
            "RED",
            "ROYAL CARIBE",
            "SAGE",
            "SAND STONE",
            "SAPPHIRE",
            "TERRACOTTA",
            "TOPAZ BLUE",
            "TRUE NAVY",
            "VINEYARD",
            "WASHED DENIM",
            "WATERMELON",
            "WINE",
            "YAM"
        ],
        "size": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL",
            "4XL"
        ],
    },
    {
        "id": "53eb930cfc",
        "name": "Adult Tank Top G2200 2D US",
        "sku": "Unisex-Gildan-TankTop",
        "color": [
            "BLACK",
            "WHITE",
            "SPORT GREY",
            "NAVY",
            "CHARCOAL",
            "RED",
            "ROYAL BLUE"
        ],
        "size": [
            "S",
            "M",
            "L",
            "XL",
            "2XL",
            "3XL"
        ],
    },
    {
        "id": "b469bda85c",
        "name": "3D-TQ CROCS (F51)",
        "sku": "Crocs",
        "color": [
            "3D Printed"
        ],
        "size": [
            ["36", "WomenUS4"],
            ["37", "WomenUS5"],
            ["38", "WomenUS6"],
            ["39", "WomenUS6.5"],
            ["40", "WomenUS7.5"],
            ["41", "WomenUS8"],
            ["42", "WomenUS9"],
            ["43", "WomenUS9.5"],
            ["44", "WomenUS10.5"],
            ["45", "WomenUS11.5"],
            ["46", "WomenUS12"],
            ["38", "MenUS3.5"],
            ["39", "MenUS4.5"],
            ["40", "MenUS5.5"],
            ["41", "MenUS6"],
            ["42", "MenUS7"],
            ["43", "MenUS7.5"],
            ["44", "MenUS8.5"],
            ["45", "MenUS9"],
            ["46", "MenUS10"],
            ["47", "MenUS11"],
            ["48", "MenUS12"],
        ]
    },

]

export default merchfox